module.exports = __webpack_public_path__ + "static/media/icon-voice.b9fad5db.svg";